import { TradeNotesState } from './reducer'
import { ActivityItem, TradeNoteItem, UnreadCounts } from './types'

type StateWithTradeNotes = { tradeNotes: TradeNotesState }

export const getActivityItems = (state: StateWithTradeNotes): ActivityItem[] =>
  state.tradeNotes.items

export const getActivityItemsForMasterTrade = (
  state: StateWithTradeNotes,
  masterTradeId: string,
): ActivityItem[] =>
  state.tradeNotes.items.filter(item => item.masterTradeId === masterTradeId)

export const getActivityItemsForSubTrade = (
  state: StateWithTradeNotes,
  subTradeId: string,
): ActivityItem[] =>
  state.tradeNotes.items.filter(item => item.subTradeId === subTradeId)

export const isNoteItem = (item: ActivityItem): item is TradeNoteItem =>
  item.kind === 'note'

export const getUnreadCounts = (state: StateWithTradeNotes): UnreadCounts =>
  state.tradeNotes.unreadCounts
